import React, { useEffect, useState } from 'react'
import Layout from 'gatsby-theme-kn/src/components/modules/Layout'
import BodyBlocks from 'gatsby-theme-kn/src/components/technical/BodyBlocks'
import HeroBlock from 'gatsby-theme-kn/src/components/blocks/HeroBlock'
import ProductIntroBlock from 'gatsby-theme-kn/src/components/blocks/ProductIntroBlock'
import PconUiToolBlock from 'gatsby-theme-kn/src/components/blocks/PconUiToolBlock'
import DownloadsBlock from 'gatsby-theme-kn/src/components/blocks/DownloadsBlock'
import RelatedProductsBlock from 'gatsby-theme-kn/src/components/blocks/RelatedProductsBlock'

import { useTranslation } from 'react-i18next'
import SEO from 'gatsby-theme-kn/src/components/modules/Seo'

const ProductPage = ({ content, locale, name, alternates }) => {
  const [metaNav, setMetaNav] = useState(null)
  const { t } = useTranslation()

  useEffect(() => {
    let metaNavItems = []

    if (content && content.body) {
      content.body.forEach((block) => {
        if (block.component === 'product_gallery_block') {
          metaNavItems.push({
            title: t('product_page.product_gallery_block.nav_title'),
            url: '#' + block._uid,
          })
        }
        if (block.component === 'pinpoint_block') {
          metaNavItems.push({
            title: t('product_page.pinpoint_block.nav_title'),
            url: '#' + block._uid,
          })
        }
        if (block.component === 'image_slider_block') {
          metaNavItems.push({
            title: t('product_page.image_slider_block.nav_title'),
            url: '#' + block._uid,
          })
        }
        if (block.component === 'video_block') {
          metaNavItems.push({
            title: t('product_page.video_block.nav_title'),
            url: '#' + block._uid,
          })
        }
        if (block.component === 'static_downloads_block') {
          metaNavItems.push({
            title: t('product_page.downloads_block.nav_title'),
            url: '#' + block._uid,
          })
        }
      })
      if (content.pcon_iframe_url) {
        metaNavItems.push({
          title: t('product_page.pcon_ui_tool_block.nav_title'),
          url: '#pcon',
        })
      }
      if (content.uploads && content.uploads.has_downloads) {
        metaNavItems.push({
          title: t('product_page.downloads_block.nav_title'),
          url: '#downloads',
        })
      }
    }
    setMetaNav(metaNavItems)
  }, [])

  return (
    <div>
      <Layout locale={locale} alternates={alternates}>
        <SEO content={content} title={name} />
        <HeroBlock
          gravity="face"
          block={{
            hero_mirrored: content.hero_mirrored,
            headline: name,
            image: content.main_image,
            reduced_height: content.reduced_height,
            hero_variant_class: 'kn-product-hero-micro',
            meta_nav_items: metaNav,
          }}
        />
        <ProductIntroBlock
          block={{
            image: content.isolated_image,
            alt: content.isolated_image_alt,
            name: name,
            headline: content.headline,
            intro: content.intro,
            highlight_text: content.highlight_text,
            main_text: content.main_text,
            main_award: content.uploads?.main_award,
            awards: content.uploads?.awards,
            hero_mirrored: content.hero_mirrored,
          }}
        />
        <BodyBlocks body={content.body} />

        {content.pcon_iframe_url?.length > 0 && (
          <>
            <span id="pcon"></span>
            <PconUiToolBlock
              block={{
                headline: t('product_page.pcon_ui_tool_block.title'),
                description: t('product_page.pcon_ui_tool_block.description'),
                pcon_ui_tool_url: content.pcon_iframe_url,
                custom_pcon_ui_tool_url: content.custom_pcon_iframe_url,
              }}
            />
          </>
        )}
        {content.uploads?.has_downloads && (
          <>
            <span id="downloads"></span>
            <DownloadsBlock
              block={{
                catalogue_kicker: name,
                catalogue_title: t(
                  'product_page.downloads_block.catalogue_title'
                ),
                catalogue_subtitle: t(
                  'product_page.downloads_block.catalogue_subtitle'
                ),
                downloads_title: t(
                  'product_page.downloads_block.downloads_title'
                ),
                certificates_title: t(
                  'product_page.downloads_block.certificates_title'
                ),
                catalog: content.uploads.catalog,
                certificates: content.uploads.certificates,
                product_downloads: content.uploads.product_downloads,
                category_hash: content.uploads.mdb_category_slug,
              }}
            />
          </>
        )}
        {content.similar_product_relations?.length > 0 && (
          <RelatedProductsBlock
            block={{
              headline: t('product_page.related_products_block.title'),
              subheadline: t('product_page.related_products_block.subtitle'),
              // products: content.similar_product_relations,
            }}
          />
        )}
      </Layout>
    </div>
  )
}

export default ProductPage
